import React from "react";
import { Container, Row, Col, Table, Image, Button } from "react-bootstrap";
import "./bill.css";

export default function BillPrintView({ bill, handleSave }) {
  if (!bill) return null;

  const LOGO_URL =
    "https://paupet-pub.s3.eu-north-1.amazonaws.com/Emerald-Logo-White.jpeg";

  const {
    billType = "customer",
    invoiceNo,
    invoiceDate,
    checkIn,
    checkOut,
    room,
    paymentMode,
    billTo,
    address,
    city,
    zip,
    gstin,
    phone,
    items = [],
  } = bill;

  /* ---------------- PRINT ---------------- */
  const handlePrint = async () => {
    try {
      await handleSave();
      window.print();
    } catch (error) {
      console.error("Save failed. Printing cancelled.");
    }
  };

  /* ---------------- TOTAL ---------------- */
  const calculateGrandTotal = () => {
    return items.reduce((sum, item) => {
      const rowTotal = Number(item.total || 0);
      const credit = Number(item.credit || 0);
      return sum + rowTotal - credit;
    }, 0);
  };

  const grandTotal = calculateGrandTotal();

  return (
    <>
      {/* PRINT BUTTON */}
      <div className="text-center mb-3 no-print">
        <Button onClick={handlePrint}>Print Invoice</Button>
      </div>

      <Container
        id="print-area"
        className="bg-white"
        style={{
          maxWidth: "820px",
          fontFamily: "Arial, sans-serif",
          color: "#000",
        }}
      >
        {/* ---------------- HEADER ---------------- */}
        <Row className="align-items-center mb-2 m-5">
          <Col xs={3}>
            <Image src={LOGO_URL} style={{ maxHeight: 80 }} fluid />
          </Col>

          <Col xs={9} className="text-end">
            <h4 className="mb-1">
              {billType === "walkin" ? "RECEIPT" : "INVOICE"}
            </h4>
            <div style={{ fontSize: 12, lineHeight: "18px" }}>
              Emerald Suites <br />
              #18, Hennur Bagalur Main Road, Narayanapura, Bengaluru - 560077
              <br />
              GSTIN : 29BMBPB8234K1ZY
            </div>
          </Col>
        </Row>

        <hr />

        {/* ---------------- DETAILS ---------------- */}
        <Row>
          <Col md={6} style={{ fontSize: 13 }}>
            <div><strong>Date:</strong> {invoiceDate}</div>
            <div><strong>Invoice No:</strong> {invoiceNo}</div>

            {/* SHOW ONLY FOR CUSTOMER */}
            {billType !== "walkin" && (
              <>
                <div><strong>Check In:</strong> {checkIn}</div>
                <div><strong>Check Out:</strong> {checkOut}</div>
                <div><strong>Room:</strong> {room}</div>
              </>
            )}

            <div><strong>Mode of Payment:</strong> {paymentMode}</div>
          </Col>

          <Col md={6} style={{ fontSize: 13 }}>
            <div>
              <strong>
                {billType === "walkin" ? "Customer" : "Bill To"}:
              </strong>{" "}
              {billTo || "-"}
            </div>

            {/* ADDRESS ONLY IF EXISTS */}
            {address && <div>{address}</div>}
            {(city || zip) && (
              <div>
                {city} {zip && `- ${zip}`}
              </div>
            )}

            {/* GST ONLY FOR CUSTOMER */}
            {billType !== "walkin" && (
              <div><strong>GSTIN:</strong> {gstin || "-"}</div>
            )}

            <div><strong>Phone:</strong> {phone || "-"}</div>
          </Col>
        </Row>

        {/* ---------------- ITEMS ---------------- */}
        <Table bordered size="sm" className="mt-3">
          <thead>
            <tr>
              <th style={{ width: 120 }}>Date</th>
              <th>Description</th>
              <th className="text-end">Charges</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>Credit</th>
              <th>Total</th>
            </tr>
          </thead>

          <tbody>
            {items.map((item, idx) => (
              <tr key={idx}>
                <td>{item.date || "-"}</td>
                <td>{item.description}</td>
                <td className="text-end">
                  {Number(item.charges || 0).toFixed(2)}
                </td>
                <td>{item.cgst}</td>
                <td>{item.sgst}</td>
                <td>{Number(item.credit || 0).toFixed(2)}</td>
                <td>{item.total}</td>
              </tr>
            ))}

            {/* TOTAL ROW */}
            <tr>
              <td colSpan={5}></td>
              <td className="text-end">
                <strong>Grand Total</strong>
              </td>
              <td className="text-end">
                <strong>{grandTotal.toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </Table>

        {/* ---------------- FOOTER ---------------- */}
        {billType !== "walkin" && (
          <>
            <Row className="mt-4">
              <Col style={{ fontSize: 12 }}>
                <strong>Guest's Signature</strong>
                <div>
                  Please deposit your room key. I agree that my liability for
                  this bill is not waived and agree to be held personally liable
                  in the event that the indicated person, company, or association
                  fails to pay.
                </div>
              </Col>
            </Row>
          </>
        )}

        <Row className="mt-3">
          <Col className="text-center">
            <strong>
              {billType === "walkin" ? "Thank You! Visit Again" : "Front Office"}
            </strong>
          </Col>
        </Row>
      </Container>
    </>
  );
}